import { useState } from "react";

export const useResetPassStates = () => {
  const [email, setEmail] = useState("");
  const [emailConfirm, setEmailConfirm] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [userName, setUserName] = useState("");
  // エラーメッセージ
  const [emailError, setEmailError] = useState("");
  const [emailConfirmError, setEmailConfirmError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [userNameError, setUserNameError] = useState("");

  // その他State定義 ============================================
  // メール送信ボタン有効フラグ
  const [isActiveSendMailButton, setIsActiveSendMailButton] = useState(false);
  // 更新ボタン有効フラグ
  const [isActiveUpdateButton, setIsActiveUpdateButton] = useState(false);

  // 確認ダイアログ表示フラグ
  const [isShowConfirmDialog, setIsShowConfirmDialog] = useState(false);

  // エラーダイアログ表示フラグ情報
  const [isShowErrorDialog, setIsShowErrorDialog] = useState({
    isError: false,
    errorMessage: "",
  });

  return {
    email,
    setEmail,
    emailError,
    setEmailError,
    emailConfirm,
    setEmailConfirm,
    emailConfirmError,
    setEmailConfirmError,
    password,
    setPassword,
    passwordConfirm,
    setPasswordConfirm,
    passwordError,
    setPasswordError,
    userName,
    setUserName,
    userNameError,
    setUserNameError,
    isActiveSendMailButton,
    setIsActiveSendMailButton,
    isActiveUpdateButton,
    setIsActiveUpdateButton,
    isShowConfirmDialog,
    setIsShowConfirmDialog,
    isShowErrorDialog,
    setIsShowErrorDialog,
  };
};
